import { ReqPost, ReqGet } from '../../config/Requests';
import { signupInitiated, signupSuccess } from './actions';

export const signupUser = (values) => async (dispatch) => {
    dispatch(signupInitiated());

    const res = await ReqPost('login', values)
    const accessToken = res.data.accessToken;
    localStorage.setItem('accessToken', accessToken);
    const profileRes = await ReqGet('profile', accessToken)
    localStorage.setItem('fullname', profileRes.data.fullname);
    localStorage.setItem('userType', profileRes.data.user_type);
    localStorage.setItem('tokenId', profileRes.data.id);
    localStorage.setItem('isLogin', true);

    const userType = localStorage.getItem('userType');


    console.log('redirect to ' + userType);
    dispatch(signupSuccess());

} 